import { useTranslation } from 'react-i18next'
import { breakpoints } from '@/styles'
import { Wrapper } from '@/features/Application/elements'
import { showInfoModal, getModalInfo } from '@/features/Application/info-modal'
import { SectionTitle } from '@/features/Application/elements'
import useMediaQuery from '@/hooks/use-media-query'
import DesktopComponent from './desktop'
import MobileComponent from './mobile'

const View = ({ data, application, isLocked, isLoading, standalone = false }) => {
  const { t } = useTranslation()

  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const title = t('l.application.view.trustworthiness.label', 'Trustworthiness')

  const { title: modalTitle, content } = getModalInfo('trustworthiness', t)
  const handleClick = () =>
    showInfoModal({
      title: modalTitle,
      content
    })

  return (
    <Wrapper id="trustworthiness">
      <SectionTitle
        title={title}
        handleInfoClick={handleClick}
        clickId="application-trust-score-info-trustworthiness"
        showInfo
        score={data?.score}
        maxScore={data?.max_score}
        rate={data?.rate}
        isLocked={isLocked}
        isLoading={isLoading}
      />
      {isMobile ? (
        <MobileComponent
          data={data}
          application={application}
          isLocked={isLocked}
          isLoading={isLoading}
          standalone={standalone}
        />
      ) : (
        <DesktopComponent
          data={data}
          application={application}
          isLocked={isLocked}
          isLoading={isLoading}
          standalone={standalone}
        />
      )}
    </Wrapper>
  )
}

export default View
